import { render, staticRenderFns } from "./ProgramProgramModuleUpdate.vue?vue&type=template&id=7e5a85b5&scoped=true"
import script from "./ProgramProgramModuleUpdate.vue?vue&type=script&lang=js"
export * from "./ProgramProgramModuleUpdate.vue?vue&type=script&lang=js"
import style0 from "./ProgramProgramModuleUpdate.vue?vue&type=style&index=0&id=7e5a85b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5a85b5",
  null
  
)

export default component.exports